import m from 'mithril/hyperscript';
import type { MithrilVNode } from '../../mithril';
import { addStyles, assetPath, DefaultTheme } from '../theme';
import { ColorPaletteGrey } from '../theme.palette';

const CSS = {
	container: 'c-CenteredCard',
	logo: 'c-CenteredCard__Logo',
	body: 'c-CenteredCard__Body',
};

addStyles({
	[CSS.container]: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${DefaultTheme.space(18)} ${DefaultTheme.space(6)} ${DefaultTheme.space(6)}`,
		margin: '20vh auto auto',
		backgroundColor: DefaultTheme.background.offWhite,
		borderRadius: DefaultTheme.space(1),
		border: `1px solid rgb(${ColorPaletteGrey.C300})`,
		minHeight: '400px',
		boxSizing: 'border-box',
	},
	[CSS.logo]: {
		width: '200px',
		paddingBottom: DefaultTheme.space(12),
	},
	[CSS.body]: {
		width: '100%',
	},
});

export interface CenteredCardCtx {
	className?: string;
}

export const CenteredCard = {
	view(children: MithrilVNode | MithrilVNode[], ctx: CenteredCardCtx = {}): MithrilVNode {
		return m('div', { className: `mdl-card ${CSS.container} ${ctx.className || ''}` }, [
			m('img', { className: CSS.logo, src: assetPath('/images/ike_logo_solid_dark.svg') }),
			m('div', { className: CSS.body }, children),
		]);
	},
};
